var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186 186",
    style: {
      enableBackground: "new 0 0 186 186"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,18.3l6.2,56.1h-5.3l-10.7-16l-1.8-2.7H4L5.5,63l6,30l-6,30L4,130.4h26.5l1.8-2.7l10.7-16h5.3l-6.2,56.1 h22l1.9-1.8l54.3-54.3h34.6c7.2,0,11.8-4.2,16-7.6c4.2-3.4,7.2-6.8,7.2-6.8L182,93l-4.1-4.3c0,0-3-3.4-7.2-6.8 c-4.2-3.4-8.8-7.6-16-7.6h-34.6L65.8,20l-1.9-1.8H41.9z M55.9,30.7h2.7L113,85l1.9,1.8h39.9c-0.3,0,4.5,2,8,4.9 c0.9,0.7,0.8,0.7,1.6,1.4c-0.7,0.7-0.7,0.7-1.6,1.4c-3.5,2.8-8.3,4.9-8,4.9h-39.9L113,101l-54.3,54.3h-2.7l6.2-56.1H36.1l-1.8,2.7 l-10.7,16h-4.5l4.7-23.7l0.4-1.2l-0.4-1.2l-4.7-23.7h4.5l10.7,16l1.8,2.7h26.1L55.9,30.7z M92.5,36.9L105,49.4h12.5l6.2-6.2 l-6.2-6.2H92.5z M105,136.6l-12.5,12.5h24.9l6.2-6.2l-6.2-6.2H105z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetX);
export default __webpack_public_path__ + "static/media/JetX.a7017dddf3b79705ae6ce9be17a1e9f4.svg";
export { ForwardRef as ReactComponent };